import React, { useState, useEffect, useMemo } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/Flats/Tables";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import BedStatus from "../../Components/AddTenant/BedStatus";
import SummaryCards from "../../Components/Room/SummaryCard";
import AddTenantPage from "../../Components/AddTenant/AddTenantPage";
import SelectPackage from "../../Components/Room/SelectPackage";
import EditPackage from "../../Components/Room/EditPackage";
import EditRoom from "../../Components/Room/EditRoom";
import { toast } from "react-toastify";
import EditFlat from "../../Components/Room/EditFlat";
import AddRoomNumber from "../../Components/Room/AddRoomNumber";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import { GrPowerReset } from "react-icons/gr";
import { Tooltip } from "react-tooltip";
import AddExtraBed from "../../Components/Room/AddExtraBed";
import DeleteExtraBed from "../../Components/Room/DeleteExtraBed";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import SideModal from "../../Components/SideModal";

const ViewBeds = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const location = useLocation();
  const navigate = useNavigate();
  const propertyDetails = location.state?.propertyDetails;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addBed, setAddBed] = useState(false);
  const [addTenant, setAddTenant] = useState(false);
  const [editPackage, setEditPackage] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [packageData, setPackageData] = useState();
  const [editModel, setEditModel] = useState(false);
  const [flatModel, setFlatModel] = useState(false);
  const [roomNumberModel, setRoomNumberModel] = useState(false);
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [PGData, setPGData] = useState([]);
  const [FlatData, setFlatData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [isExtraBed, setIsExtraBed] = useState(false);
  const [isExtraBedDelete, setIsExtraBedDelete] = useState(false);
  const [summary, setSummary] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(
    propertyDetails || null
  );

  const effectivePropertyId = selectedProperty.id;
  const currentPropId = effectivePropertyId;
  const isFlat = selectedProperty?.type === 2;

  const query = isFlat
    ? `/room/list-for-flat/client/${currentPropId}`
    : `/room/list/client/${currentPropId}`;

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) {
      error = true;
    } else {
      const allRooms = isFlat
        ? res?.data?.flats?.flatMap((flat) => flat.rooms) || []
        : res?.data?.floors?.flatMap((floor) => floor.rooms) || [];

      setPGData(
        res?.data?.floors ? res.data.floors.flatMap((floor) => floor.rooms) : []
      );

      setFlatData(
        res?.data?.flats ? res?.data?.flats.flatMap((flat) => flat.rooms) : []
      );
      setSummary(res?.stats);
      setRooms(allRooms);
      setPropData(isFlat ? res?.data?.flats : res?.data?.floors);
      setFilteredRooms(allRooms);
    }
  };
  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (currentPropId === 0) {
      navigate("/inventory/operational");
      return;
    }
    setSelectedFloor(null);

    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [currentPropId, navigate]);

  const propStatus = data?.data?.property?.status;

  useEffect(() => {
    if (!selectedFloor) {
      setFilteredRooms(rooms);
    } else {
      const timer = setTimeout(() => {
        let filteredRoomsTemp = [];
        if (selectedFloor.floor !== undefined) {
          filteredRoomsTemp = rooms.filter(
            (room) => room.floor == selectedFloor.floor
          );
          if (filteredRoomsTemp.length === 0) {
            filteredRoomsTemp.push(selectedFloor);
          }
        } else {
          filteredRoomsTemp = rooms.filter(
            (room) => room.flatId == selectedFloor.id
          );
          if (filteredRoomsTemp.length === 0) {
            filteredRoomsTemp.push(selectedFloor);
          }
        }
        setFilteredRooms(filteredRoomsTemp);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [selectedFloor, rooms]);

  const handleFloorSelect = (selection) => {
    setSelectedFloor(selection);
  };

  const handleAddPackageClose = () => {
    setAddBed(false);
    setIsCreatingNew(false);
  };
  const handleEditPackageClose = () => {
    setEditPackage(false);
  };

  //------- Create Opion Bed -------
  const AddOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/option/create`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAddOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setAddBed(true);
      setIsCreatingNew(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addOptionLoading, mutate: addOptionMutate } = useMutation(
    AddOptionFunction,
    {
      onSuccess: onAddOptionSuccess,
      onError: onAddOptionError,
    }
  );

  //------- Select Opion Bed -------
  const SelectOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/beds/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onSelectOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setAddBed(false);
      setIsCreatingNew(false);
      getListMutate();
      setSelectedFloor(null)
      // setSelectedFloor((prev) => ({ ...prev }));
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onSelectOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addSelectLoading, mutate: addSelectMutate } = useMutation(
    SelectOptionFunction,
    {
      onSuccess: onSelectOptionSuccess,
      onError: onSelectOptionError,
    }
  );

  //------- Edit Opion Bed -------
  const EditOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/option/update`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditPackage(false);
      setAddBed(true);
      setIsCreatingNew(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editOptionLoading, mutate: editOptionMutate } =
    useMutation(EditOptionFunction, {
      onSuccess: onEditOptionSuccess,
      onError: onEditOptionError,
    });

  //------- Edit Room Number -------
  const EditRoomNumberFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditRoomNumberSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditRoomNumberError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editRoomNumberLoading, mutate: editRoomNumberMutate } =
    useMutation(EditRoomNumberFunction, {
      onSuccess: onEditRoomNumberSuccess,
      onError: onEditRoomNumberError,
    });

  //------- Deactivate Room  -------
  const DeactivateRoomFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/status/deactivate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onRoomDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onRoomDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateRoomLoading, mutate: deactivateRoomMutate } =
    useMutation(DeactivateRoomFunction, {
      onSuccess: onRoomDeactivateSuccess,
      onError: onRoomDeactivateError,
    });

  //------- Activate Room  -------
  const ActivateRoomFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/status/activate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onRoomActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onRoomActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: activateRoomLoading, mutate: activateRoomMutate } =
    useMutation(ActivateRoomFunction, {
      onSuccess: onRoomActivateSuccess,
      onError: onRoomActivateError,
    });

  //------- Edit Flat Number -------
  const EditFlatNumberFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/name/update`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditFlatNumberSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditFlatNumberError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editFlatNumberLoading, mutate: editFlatNumberMutate } =
    useMutation(EditFlatNumberFunction, {
      onSuccess: onEditFlatNumberSuccess,
      onError: onEditFlatNumberError,
    });

  //------- Deactivate Flat  -------
  const DeactivateFlatFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/status/deactivate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onFlatDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onFlatDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateFlatLoading, mutate: deactivateFlatMutate } =
    useMutation(DeactivateFlatFunction, {
      onSuccess: onFlatDeactivateSuccess,
      onError: onFlatDeactivateError,
    });

  //------- Activate Flat  -------
  const ActivateFlatFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/status/activate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onFlatActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onFlatActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: activateFlatLoading, mutate: activateFlatMutate } =
    useMutation(ActivateFlatFunction, {
      onSuccess: onFlatActivateSuccess,
      onError: onFlatActivateError,
    });

  // Add Room
  const apiRoomUrl = isFlat
    ? `${Config.apiUrl}/room/add-for-flat`
    : `${Config.apiUrl}/room/add`;

  const AddRoomFunction = async (values) => {
    return await axios.post(apiRoomUrl, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAddRoomSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setRoomNumberModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddRoomError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addRoomNumberLoading, mutate: addRoomNumberMutate } =
    useMutation(AddRoomFunction, {
      onSuccess: onAddRoomSuccess,
      onError: onAddRoomError,
    });

  //------- Activate Property -------
  const ActivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/activate `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: activateLoading, mutate: activateMutate } = useMutation(
    ActivateFunction,
    {
      onSuccess: onActivateSuccess,
      onError: onActivateError,
    }
  );

  //------- Deactivate Property -------
  const DeactivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/deactivate  `,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: DeactivateLoading, mutate: deactivateMutate } =
    useMutation(DeactivateFunction, {
      onSuccess: onDeactivateSuccess,
      onError: onDeactivateError,
    });

  //------- Extra Bed Add -------
  const addExtraBedFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/extra-bed/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onExtraBedSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsExtraBed(false);
      //refetch();
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onExtraBedError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addExtraBedLoading, mutate: addExtraBedMutate } =
    useMutation(addExtraBedFunction, {
      onSuccess: onExtraBedSuccess,
      onError: onExtraBedError,
    });

  //------- Extra Bed Delete -------
  const deleteExtraBedFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room//extra-bed/remove`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onExtraBedDeleteSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsExtraBedDelete(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onExtraBedDeleteError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteExtraBedLoading, mutate: deleteExtraBedMutate } =
    useMutation(deleteExtraBedFunction, {
      onSuccess: onExtraBedDeleteSuccess,
      onError: onExtraBedDeleteError,
    });

  const statusOptions = {
    3: { label: "Active", options: [{ value: 4, label: "Inactive" }] },
    2: { label: "Completed", options: [{ value: 3, label: "Active" }] },
    4: { label: "Inactive", options: [{ value: 3, label: "Active" }] },
  };

  const currentStatus = statusOptions[propStatus] || {
    label: "Unknown",
    options: [],
  };

  const handleStatusChange = (event) => {
    const selectedValue = event.target.value;
    const payload = { propId: currentPropId };
    if (selectedValue === 3) activateMutate(payload);
    else if (selectedValue === 4) deactivateMutate(payload);
  };

  const handleClearFilter = () => {
    setSelectedFilter(null);
    setSelectedId(null);
    setSelectedFloor(null);
  };

  const handleRefresh = () => {
    getListMutate();
  };

  return currentPropId !== 0 ? (
    <>
      {isModalOpen && <BedStatus setIsModalOpen={setIsModalOpen} />}

      <SideModal
        isOpen={addBed}
        onClose={() => setAddBed(false)}
      >
        <SelectPackage
          setAddTenant={setAddBed}
          addBed={addBed}
          handleClose={handleAddPackageClose}
          setEditPackage={setEditPackage}
          setPackageData={setPackageData}
          addOptionLoading={addOptionLoading}
          addOptionMutate={addOptionMutate}
          setIsCreatingNew={setIsCreatingNew}
          isCreatingNew={isCreatingNew}
          selectedData={selectedData}
          addSelectLoading={addSelectLoading}
          addSelectMutate={addSelectMutate}
          propId={currentPropId}
          security={propertyDetails?.security}
        />
      </SideModal>

      <SideModal
        isOpen={editPackage}
        onClose={() => setEditPackage(false)}
      >
        <EditPackage
          setEditPackage={setEditPackage}
          editPackage={editPackage}
          handleClose={handleEditPackageClose}
          packageData={packageData}
          editOptionLoading={editOptionLoading}
          editOptionMutate={editOptionMutate}
        />
      </SideModal>

      <SideModal
        isOpen={addTenant}
        onClose={() => setAddTenant(false)}
      >
        <AddTenantPage
          setAddTenant={setAddTenant}
          addTenant={addTenant}
          selectedData={selectedData}
          getListMutate={getListMutate}
          propId={currentPropId}
          handleRefresh={handleRefresh}
          route="viewBeds"
        />
      </SideModal>


      {editModel && (
        <EditRoom
          setEditModel={setEditModel}
          selectedData={selectedData}
          editRoomNumberLoading={editRoomNumberLoading}
          editRoomNumberMutate={editRoomNumberMutate}
          activateRoomLoading={activateRoomLoading}
          activateRoomMutate={activateRoomMutate}
          deactivateRoomLoading={deactivateRoomLoading}
          deactivateRoomMutate={deactivateRoomMutate}
          setIsExtraBed={setIsExtraBed}
          setSelectedData={setSelectedData}
        />
      )}

      {isExtraBed && (
        <AddExtraBed
          setIsExtraBed={setIsExtraBed}
          selectedData={selectedData}
          addExtraBedLoading={addExtraBedLoading}
          addExtraBedMutate={addExtraBedMutate}
        />
      )}

      {isExtraBedDelete && (
        <DeleteExtraBed
          setIsExtraBedDelete={setIsExtraBedDelete}
          selectedData={selectedData}
          deleteExtraBedLoading={deleteExtraBedLoading}
          deleteExtraBedMutate={deleteExtraBedMutate}
        />
      )}

      {flatModel && (
        <EditFlat
          setFlatModel={setFlatModel}
          selectedData={selectedData}
          editFlatNumberLoading={editFlatNumberLoading}
          editFlatNumberMutate={editFlatNumberMutate}
          activateFlatLoading={activateFlatLoading}
          activateFlatMutate={activateFlatMutate}
          deactivateFlatLoading={deactivateFlatLoading}
          deactivateFlatMutate={deactivateFlatMutate}
        />
      )}

      {roomNumberModel && (
        <AddRoomNumber
          setRoomNumberModel={setRoomNumberModel}
          selectedData={selectedData}
          addRoomNumberLoading={addRoomNumberLoading}
          addRoomNumberMutate={addRoomNumberMutate}
          propId={currentPropId}
          isFlat={isFlat}
        />
      )}

      <BoxContainer>
        <BoxHead>
          <BoxTitle className="mb-0 whitespace-nowrap">
            <div className="flex" onClick={() => navigate(-1)}>
              <span className="hover:bg-gray-200 items-center pt-[5px]">
                <IoChevronBackOutline
                  size={20}
                //className="text-primary-color"
                />
              </span>
              <div>
                <span className="flex items-center cursor-pointer">
                  {propertyDetails?.name}'s Rooms
                </span>
                <Underline />
              </div>
            </div>
          </BoxTitle>
          <div className="flex gap-4">
            <div>
              <ResetBtn
                type="button"
                data-tooltip-id="reset-button"
                title="Clear Filter"
                onClick={handleClearFilter}
                className={`${!selectedFilter ? "bg-gray-50 text-gray-500" : ""
                  } flex items-center gap-1`}
              >
                <span>Clear Filter</span>
                <GrPowerReset size={14} />
              </ResetBtn>
              <Tooltip
                id="reset-button"
                place="top"
                content="Clear Filter"
                style={{ backgroundColor: "#FFFFFF", color: "#808080" }}
              />
            </div>
          </div>
        </BoxHead>
        {(isLoading || isRefetching) && <SummarySkeletonLoading count={5} />}
        {!error && !isLoading && !isRefetching && summary && (
          <SummaryCards
            summaryData={summary}
            setSelectedFilter={setSelectedFilter}
            selectedFilter={selectedFilter}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            handleClearFilter={handleClearFilter}
          />
        )}
        {!error && !isLoading && data && (
          <div className="pb-12">
            <FloorTabs>
              <FloorTab
                key="ALL"
                onClick={() => handleFloorSelect(null)}
                $active={!selectedFloor}
              >
                All Rooms
              </FloorTab>
              {isFlat
                ? propData.map((floorData, index) => (
                  <FloorTab
                    key={index}
                    onClick={() => handleFloorSelect(floorData)}
                    $active={selectedFloor?.id == floorData.id}
                  >
                    Flat {floorData.name}
                  </FloorTab>
                ))
                : propData.map((floorData, index) => (
                  <FloorTab
                    key={index}
                    onClick={() => handleFloorSelect(floorData)}
                    $active={selectedFloor?.floor == floorData.floor}
                  >
                    {"Floor " + floorData.floor}
                  </FloorTab>
                ))}
            </FloorTabs>

            {/* {filteredRooms.length === 0 && (
              <NoRoomsMessage>
                No rooms found for this selection.
                Add a room to get started.
              </NoRoomsMessage>
            )} */}
            {filteredRooms.length === 0 && !selectedFloor && (
              <NoRoomsMessage>
                <p className="text-base font-medium text-gray-800">
                  Select a floor to add rooms
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  Rooms can only be added under a specific floor.
                </p>
                <p className="text-xs text-gray-400 mt-3">
                  Choose a floor tab above to continue
                </p>
              </NoRoomsMessage>
            )}
            {!error && !isLoading && filteredRooms.length > 0 && (
              <TableWrapper className="border border-gray-200 rounded-lg overflow-hidden">
                {/* <div className="px-4 py-3 bg-gray-50 border-b text-sm font-medium text-gray-700">
                  Rooms List
                </div> */}
                <Table
                  apiData={error ? [] : filteredRooms}
                  isFlat={isFlat}
                  setAddBed={setAddBed}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  setAddTenant={setAddTenant}
                  setEditModel={setEditModel}
                  setFlatModel={setFlatModel}
                  setRoomNumberModel={setRoomNumberModel}
                  propStatus={propStatus}
                  selectedFilter={selectedFilter}
                  selectedFloor={selectedFloor}
                  setIsExtraBed={setIsExtraBed}
                  setIsExtraBedDelete={setIsExtraBedDelete}
                />
                {error && !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
          </div>
        )}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  ) : (
    <Loading />
  );
};

const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-3  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const TableWrapper = tw.div`my-4 bg-white rounded-md`;
// const NoRoomsMessage = tw.div`
//     text-center text-lg font-semibold text-gray-700 bg-gray-100 p-4 rounded-md mt-4
// `;
const NoRoomsMessage = tw.div`
  text-center bg-gray-50 border border-dashed border-gray-300
  p-10 rounded-xl mt-8
`;

const ResetBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-3 cursor-pointer bg-gray-100 py-2.5 text-sm`;
export default ViewBeds;
